/**
 * Route for `cpalead-integration`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CpaleadIntegrationPage } from "../features/cpalead-integration/CpaleadIntegrationPage";

export const cpaleadIntegrationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/cpalead-integration",
	component: CpaleadIntegrationPage,
});

export default cpaleadIntegrationRoute;
